import { render, staticRenderFns } from "./SearchBuddy.vue?vue&type=template&id=33e78fa2&scoped=true&"
import script from "./SearchBuddy.vue?vue&type=script&lang=js&"
export * from "./SearchBuddy.vue?vue&type=script&lang=js&"
import style0 from "./SearchBuddy.vue?vue&type=style&index=0&id=33e78fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e78fa2",
  null
  
)

export default component.exports